import Vue from 'vue'
import Router from 'vue-router'
import content from '@/views/index/content.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'content',
      component: content
    },{
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index.vue')
    },{
      path: '/service',
      name: 'service',
      component: () => import('@/views/service/index.vue')
    },{
      path: '/supply',
      name: 'supply',
      component: () => import('@/views/supply/index.vue')
    },{
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/components/privacy.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js